import { Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { SubmitComponent, TextComponent, RadioComponent } from '@app/shared/forms';
import { StudentFacade } from '@app/admin/store/student';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, tap } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UserFacade } from '@app/store/user';
import { StudentRole } from '@app/admin/store/types';
import { FormValidators } from '@corelabs/angular-forms';
import { TextareaComponent } from '@app/shared/forms/textarea/textarea.component';

@Component({
    selector: 'app-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss'],
    imports: [ReactiveFormsModule, TranslateModule, TextComponent, SubmitComponent, RadioComponent, TextareaComponent],
    host: { id: 'students' },
})
export class AddComponent implements OnInit, OnDestroy {
    private readonly studentFacade = inject(StudentFacade);
    private readonly userFacade = inject(UserFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);
    private readonly destroyRef = inject(DestroyRef);
    private readonly router = inject(Router);
    readonly activatedRoute = inject(ActivatedRoute);

    readonly saved$ = this.studentFacade.saved$;
    readonly saving$ = this.studentFacade.saving$;

    readonly form = this.formBuilder.group({
        firstName: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text, FormValidators.MaxLength(50)]),
        lastName: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text, FormValidators.MaxLength(50)]),
        email: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text, FormValidators.Email]),
        location: this.formBuilder.control(''),
        role: this.formBuilder.control<StudentRole>('teacher'),
        description: this.formBuilder.control(''),
    });

    ngOnInit() {
        this.studentFacade.saved$
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                filter((saved) => saved === true),
                tap(() => this.router.navigate([{ outlets: { modal: null } }])),
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.studentFacade.clear();
    }

    onSubmit() {
        const value = this.form.getRawValue();
        const schoolId = this.userFacade.user()?.schoolId;
        this.form.markAllAsTouched();

        if (this.form.invalid || !schoolId) return;

        this.studentFacade.addStudent({ ...value, schoolId });
    }
}
